<template>
  <div class="head-menu">
    <div class="public-width">
      <a-row>
        <a-col :span="6">
          <span style="color:#999999;"> 您好，欢迎来到好气网 </span>
          <span style="color:#333333;">
            登录
            <span style="color:#FBA129;">免费注册</span>
          </span>
        </a-col>
        <a-col :span="16" class="right">
          <a-dropdown v-for="(item, index) in menuArr" :key="index">
            <a :class="['ant-dropdown-link',{'ant-dropdown-color':item.blur}]">
              <a-icon type="phone" v-if="item.showIcon" />
              {{ item.text }}
              <a-icon type="down" v-if="item.children" />
            </a>
            <template v-if="item.children">
              <a-menu slot="overlay" @click="dropdownChange">
                <a-menu-item v-for="child in item.children" :key="child.text">
                  <a href="javascript:;">{{ child.text }}</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "header-menu",
  data() {
    return {
      menuArr: [
        {
          text: "买家中心",
          children: [
            {
              text: "发布求购",
              url: "",
            },
            {
              text: "我的求购",
              url: "",
            },
            {
              text: "我的采购协议",
              url: "",
            },
            {
              text: "我的采购订单",
              url: "",
            },
          ],
        },
        {
          text: "卖家中心",
          children: [
            {
              text: "我的报价",
              url: "",
            },
            {
              text: "挂牌管理",
              url: "",
            },
            {
              text: "我的销售协议",
              url: "",
            },
            {
              text: "我的销售订单",
              url: "",
            },
          ],
        },
        {
          text: "承运商中心",
        },
        {
          text: "客服中心",
          children: [
            {
              text: "帮助中心",
              url: "",
            },
            {
              text: "商务合作",
              url: "",
            },
          ],
        },
        {
          text: "采购助手",
          blur:true
        },
        {
          text: "400-185-6919",
          showIcon: true,
          blur:true
        },
      ],
    };
  },
  methods: {
    dropdownChange(e) {
      // this.menuArr[e.item.index].text = e.key;
      console.log(e);
    },
  },
};
</script>

<style lang="less" scope>
@import "./index.less";
</style>
